import React from 'react';
import { useTranslation } from 'react-i18next';

export type NutritionBackCapturePillProps = {
  captureMode?: 'live' | 'back_capture' | undefined;
};

const NutritionBackCapturePill: React.FC<NutritionBackCapturePillProps> = ({ captureMode }) => {
  const { t } = useTranslation();
  if (captureMode !== 'back_capture') return null;

  return (
    <span
      className="pat-status-pill pat-status-pill--info"
      data-testid="nutrition-back-capture-pill"
    >
      <i className="bi bi-pencil-square" aria-hidden="true" />
      {' '}
      {t('nutrition.backCapture.pill.label')}
    </span>
  );
};

export default NutritionBackCapturePill;
